import React from 'react';
import { connect } from 'react-redux';
import {
  ApplicationState,
  CaseSettingsState,
  AppState,
  CaseSettingsActionCreators,
  VehicleActionCreators,
  VehicleState
} from '../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import {
  Button,
  Card,
  AppBar,
  Tabs,
  Tab,
  Dialog,
  IconButton,
  DialogTitle,
  DialogContent
} from '@material-ui/core';
import { AppContext, ApplicationContext } from '../../context/Contexts';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { RouteComponentProps } from 'react-router';
import { IReferentialService } from '../../services/Interfaces/IReferentialService';
import {ReferentialCode, RoleClaimsEnum, mavoVehicleStatuses } from '../../helpers/Constants';
import Referentials from '../../helpers/Referentials.json';
import { IReferential } from '../../interfaces/IReferential';
import { IVehicleService } from '../../services/Interfaces/IVehicleService';
import {  MavoVehicle, MavoVehicleAttachment, MavoVehicleAuction, MavoVehicleAuctionOffer, VehicleConditionInfo, VehicleOptionInfo } from '../../interfaces/Vehicle';
import TabPanel from '../_shared/Tabs';
import * as R from 'ramda';
import { MavoVehicleActionCreators } from '../../store/actions/MavoVehicle';
import { MavoVehicleState } from '../../store/reducers/MavoVehicle';
import MavoGeneralInformationContainer from './MavoGeneralInformationContainer';
import MavoVehicleOptionsContainer from './MavoVehicleOptionsContainer';
import MavoAttachmentDataContainer from './MavoAttachmentDataContainer';
import { ScaleLoader } from 'react-spinners';
import MavoStatusDataContainer from './MavoStatusDataContainer';
import { VehicleAuctionActionCreators } from '../../store/actions/VehicleAuction';
import NavigationIcon from '@material-ui/icons/Navigation';
import _ from 'lodash';
import AddAuctionOfferDialog from './AddAuctionOfferDialog';
import CloseIcon from '@material-ui/icons/Close';

interface IMavoVehicleDetailsViewFormState {
  isLoading: boolean;
  executing: boolean;
  isUserHidden: boolean;
  vehicle: MavoVehicle;
  selectedTab: number;
  statuses: IReferential[];
  statusOptions: IReferential[];
  selectedDisplayedStatus: string;
  isChangeVehicleStatusDialogOpen: boolean;
  isOfferDialogOpen: boolean;
  mavoVehicleAuctionOffer: MavoVehicleAuctionOffer;
}

export interface ExternalMavoVehicleDetailsViewFormProps {
  mavoVehicleAuction: MavoVehicleAuction;
  closeDialog: () => void;
  goToUserAuctions: () => void;
} 

type IMavoVehicleDetailsViewFormProps = ExternalMavoVehicleDetailsViewFormProps & {
  caseSettingsState: CaseSettingsState;
  appState: AppState;
  vehicleState: VehicleState;
  mavoVehicleState: MavoVehicleState;
  mavoVehicleAuctionState: MavoVehicleAuction;
} & typeof CaseSettingsActionCreators &
  typeof VehicleActionCreators &
  typeof MavoVehicleActionCreators &  typeof VehicleAuctionActionCreators &
  ProviderContext &
  RouteComponentProps<{ id: string }>;

class MavoVehicleDetailsViewForm extends React.PureComponent<IMavoVehicleDetailsViewFormProps, IMavoVehicleDetailsViewFormState> {
  private translatorService!: ITranslatorService;
  private vehicleService!: IVehicleService;
  private appReferentialService!: IReferentialService;

  static contextType = ApplicationContext;

  state = {
    isLoading: true,
    executing: false,
    isUserHidden: false,
    selectedTab: 0,
    statuses: [] as IReferential[],
    statusOptions: [],
    isChangeVehicleStatusDialogOpen: false,
    isOfferDialogOpen: false,
    mavoVehicleAuctionOffer: {
      mavoVehicleAuctionId: 0,
      id: 0
      } as MavoVehicleAuctionOffer,
    vehicle: {
      id: 0,
      vin: '',
      make: null,
      makeId: null,
      model: null,
      modelId: null,
      versionItem: null,
      versionId: null,
      color: null,
      colorId: null,
      fuelType: null,
      fuelTypeId: null,
      bodyTypeId: null,
      bodyType: null,
      transmissionTypeId: null,
      transmissionType: null,
      provenance: null,
      provenanceId: null,
      firstRegistrationDate: '',
      fabricationYear: null,
      kilometersNr: null,
      power: null,
      engineManufactureCode: '',
      accessories: null,
      isReserved: false,
      reservations: '',
      cylinderCapacity: null,
      supplier: null,
      location: null,
      htPurchaseRonPrice: null,
      ttcEvaluationEurPrice: null,
      nirNumber: null,
      nirDate: null,
      currentStatus: null,
      vehicleOptions: [],
      vehicleType: null,
      vehicleTypeId: null,
      mavoVehicleAttachments: [] as MavoVehicleAttachment[],
      vehicleOptionInfo: {
        vehicleId: 0,
        engineCapacity: null,
        emissionsClass: null,
        doorCount: null,
        seatCount: null,
        driveType: null,
        registration: null,
        vehicleCondition: null,
        metallicColor: null,
        upholstery: null,
        upholsteryColor: null,
        previousOwnersCount: null,
        countryOfOrigin: null,
        alarm: false,
        antiTheft: false,
        abs: false,
        esp: false,
        driverFrontAirbag: false,
        passengerFrontAirbag: false,
        frontSideAirbags: false,
        frontCurtainAirbag: false,
        xenonHeadlights: false,
        alloyWheels: false,
        glassRoof: false,
        towHook: false,
        protectionFrame: false,
        steeringWheelControls: false,
        onBoardComputer: false,
        cruiseControl: false,
        lockableDifferential: false,
        particleFilter: false,
        electricMirrors: false,
        frontElectricWindows: false,
        rearElectricWindows: false,
        tintedWindows: false,
        heatedSeats: false,
        rainSensors: false,
        parkingSensors: false,
        powerSteering: false,
        sunroof: false,
        rightHandDrive: false,
        fogLights: false,
        airConditioning: false,
        radio: false,
        cdPlayer: false,
        videoScreen: false,
        gps: false
      } as VehicleOptionInfo,
      vehicleConditionInfo: {
        vehicleId: 0,
        frontWingLeftPaintId: null,
        frontWingLeftPaint: null,
        frontWingRightPaintId: null,
        frontWingRightPaint: null,
        rearWingLeftPaintId: null,
        rearWingLeftPaint: null,
        rearWingRightPaintId: null,
        rearWingRightPaint: null,
        frontDoorLeftPaintId: null,
        frontDoorLeftPaint: null,
        frontDoorRightPaintId: null,
        frontDoorRightPaint: null,
        rearDoorLeftPaintId: null,
        rearDoorLeftPaint: null,
        rearDoorRightPaintId: null,
        rearDoorRightPaint: null,
        hoodPaintId: null,
        hoodPaint: null,
        faceMaskPaintId: null,
        faceMaskPaint: null,
        frontBumperPaintId: null,
        frontBumperPaint: null,
        rearBumperPaintId: null,
        rearBumperPaint: null,
        trunkPaintId: null,
        trunkPaint: null,
        spoilerPaintId: null,
        spoilerPaint: null,
        roofPaintId: null,
        roofPaint: null,
        superstructurePaintId: null,
        superstructurePaint: null,
      
        // Tinichigerie + Vopsitorie (Bodywork + Painting)
        frontWingLeftBodyPaintId: null,
        frontWingLeftBodyPaint: null,
        frontWingRightBodyPaintId: null,
        frontWingRightBodyPaint: null,
        rearWingLeftBodyPaintId: null,
        rearWingLeftBodyPaint: null,
        rearWingRightBodyPaintId: null,
        rearWingRightBodyPaint: null,
        frontDoorLeftBodyPaintId: null,
        frontDoorLeftBodyPaint: null,
        frontDoorRightBodyPaintId: null,
        frontDoorRightBodyPaint: null,
        rearDoorLeftBodyPaintId: null,
        rearDoorLeftBodyPaint: null,
        rearDoorRightBodyPaintId: null,
        rearDoorRightBodyPaint: null,
        hoodBodyPaintId: null,
        hoodBodyPaint: null,
        faceMaskBodyPaintId: null,
        faceMaskBodyPaint: null,
        frontBumperBodyPaintId: null,
        frontBumperBodyPaint: null,
        rearBumperBodyPaintId: null,
        rearBumperBodyPaint: null,
        trunkBodyPaintId: null,
        trunkBodyPaint: null,
        spoilerBodyPaintId: null,
        spoilerBodyPaint: null,
        roofBodyPaintId: null,
        roofBodyPaint: null,
        superstructureBodyPaintId: null,
        superstructureBodyPaint: null,
      
        // Replacement & Painting (Inlcuire + vopsire)
        frontWingLeftReplacePaintId: null,
        frontWingLeftReplacePaint: null,
        frontWingRightReplacePaintId: null,
        frontWingRightReplacePaint: null,
        rearWingLeftReplacePaintId: null,
        rearWingLeftReplacePaint: null,
        rearWingRightReplacePaintId: null,
        rearWingRightReplacePaint: null,
        frontDoorLeftReplacePaintId: null,
        frontDoorLeftReplacePaint: null,
        frontDoorRightReplacePaintId: null,
        frontDoorRightReplacePaint: null,
        rearDoorLeftReplacePaintId: null,
        rearDoorLeftReplacePaint: null,
        rearDoorRightReplacePaintId: null,
        rearDoorRightReplacePaint: null,
        hoodReplacePaintId: null,
        hoodReplacePaint: null,
        faceMaskReplacePaintId: null,
        faceMaskReplacePaint: null,
        frontBumperReplacePaintId: null,
        frontBumperReplacePaint: null,
        rearBumperReplacePaintId: null,
        rearBumperReplacePaint: null,
        trunkReplacePaintId: null,
        trunkReplacePaint: null,
        spoilerReplacePaintId: null,
        spoilerReplacePaint: null,
        roofReplacePaintId: null,
        roofReplacePaint: null,
        superstructureReplacePaintId: null,
        superstructureReplacePaint: null,

        //Inlocuire/Reparatie
        frontLeftSideWindowToReplace: false,
        frontLeftSideWindowToRepair: false,
        frontRightSideWindowToReplace: false,
        frontRightSideWindowToRepair: false,
      
        rearLeftSideWindowToReplace: false,
        rearLeftSideWindowToRepair: false,
        rearRightSideWindowToReplace: false,
        rearRightSideWindowToRepair: false,
      
        leftSideMirrorToReplace: false,
        leftSideMirrorToRepair: false,
        rightSideMirrorToReplace: false,
        rightSideMirrorToRepair: false,
      
        leftWiperToReplace: false,
        leftWiperToRepair: false,
        rightWiperToReplace: false,
        rightWiperToRepair: false,
      
        leftProjectorToReplace: false,
        leftProjectorToRepair: false,
        rightProjectorToReplace: false,
        rightProjectorToRepair: false,
      
        leftTurnSignalToReplace: false,
        leftTurnSignalToRepair: false,
        rightTurnSignalToReplace: false,
        rightTurnSignalToRepair: false,
      
        leftHeadlightToReplace: false,
        leftHeadlightToRepair: false,
        rightHeadlightToReplace: false,
        rightHeadlightToRepair: false,
      
        leftBrakeLightsToReplace: false,
        leftBrakeLightsToRepair: false,
        rightBrakeLightsToReplace: false,
        rightBrakeLightsToRepair: false,
      
        rearWindshieldToReplace: false,
        rearWindshieldToRepair: false,
      
        windshieldToReplace: false,
        windshieldToRepair: false,
      
        hoodGrilleToReplace: false,
        hoodGrilleToRepair: false,
      
        //Mecanica
        motor: null,
        clutch: null,
        gearbox: null,
        steering: null,
        battery: null,
        exhaust: null,
        tires: null,
        driveShaft: null,
        leftCvJoints: null,
        rightCvJoints: null,
        leftShockAbsorbers: null,
        rightShockAbsorbers: null,
        frontBrakes: null,
        backBrakes: null,
        itpValidateDate: null,
      
        //Interior si accesorii
        leftSeatUpholstery: null,
        rightSeatUpholstery: null,
        rearSeatUpholstery: null,
        interiorMirror: null,
        firstAidKit: null,    
        bulbKit: null,  
        leftFrontHeadrest: null,     
        rightFrontHeadrest: null,
        rearHeadrest: null,
        spareTireGood: false,
        spareTireReplace: false,
        frontFloorMats: false,
        fireExtinguisher: false,
        wheelWrench: false,
        rearFloorMats: false,
        reflectiveTriangle: false, 
        carJack: false,
      } as VehicleConditionInfo
    } as unknown as MavoVehicle,
    selectedDisplayedStatus: ''
  } as IMavoVehicleDetailsViewFormState;

  public componentDidMount() {   
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadMavoVehicle();
      }
    );
  }

  loadMavoVehicle = async () => {
    const statusesTypeRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.VehicleStatus
    );
    const statuses = (await this.appReferentialService.Get(statusesTypeRef!.baseUrl)).filter(x => mavoVehicleStatuses.includes(x.id));
    
    await this.props.setMavoVehicle(this.props.mavoVehicleAuction.mavoVehicleId);

    const vehicle = this.props.mavoVehicleState.mavoVehicle;

    this.setState({
      isLoading: false,
      vehicle: vehicle,
      statuses: statuses,
      selectedDisplayedStatus: !R.isNil(vehicle?.currentStatus?.status)
        ? vehicle?.currentStatus?.status?.displayName || ''
        : ''
    });
  };

  closeDialog = async () => {
    this.setState({ isChangeVehicleStatusDialogOpen: false });
  };

  onTabChange = (event: any, newValue: number) => {
    this.setState({
      selectedTab: newValue
    });
  };

  openAddOfferDialog = () => {
    this.setState({
      isOfferDialogOpen: true
    });
  }

  closeAddOfferDialog = () => {
    this.setState({
      isOfferDialogOpen: false
    });
  };

  public hasRight = (right: string): boolean => {
    return this.props.appState!.user!.profile.role.includes(right);
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.vehicleService = (this.context as AppContext).vehicleService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    return (
      <div>
        <React.Fragment>
          <Card className="mb-3 p-3">
            <div className="d-flex align-items-center">
              <div style={{ flexBasis: '50%' }}>
              </div>
              <div style={{ flexBasis: '50%' }}>
                <Button
                  className="ml-2 float-right"
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.props.closeDialog();
                  }}
                >
                  <NavigationIcon />
                  {this.translatorService.Tranlate(
                    'MENU_MAVO_VEHICLES_AUCTIONS_RECORD',
                    'Inapoi la lista'
                  )}
                </Button>
                {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? null : (
                  <Button
                    className="ml-2 float-right bg-theme-primary"
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      this.openAddOfferDialog();
                    }}
                  >
                    {this.translatorService.Tranlate(
                      'MAVO_VEHICLES_VEHICLE_BID',
                      'Liciteaza'
                    )}
                  </Button>
                )}
              </div>
            </div>
          </Card>
        </React.Fragment>
        <React.Fragment>
          <Card>
            <AppBar position="static" elevation={0} color="secondary">
              <Tabs
                  TabIndicatorProps={{
                    style: {
                      height: '4px'
                    }
                  }}
                  value={this.state.selectedTab}
                  onChange={this.onTabChange}
                  variant="fullWidth"
                  centered={true}
                  indicatorColor="primary"
                  aria-label="simple tabs example"
                >
                  <Tab
                    label={this.translatorService.Tranlate(
                      'MAVO_VEHICLE_GENERAL_INFORMATION_TAB',
                      'Informatii generale'
                    )}
                  />
                  <Tab
                    label={this.translatorService.Tranlate('MAVO_VEHICLE_STATUS_VEHICLE_TAB', 'Stare vehicul')}
                  /> 
                  <Tab
                    label={this.translatorService.Tranlate('MAVO_VEHICLE_OPTIONS_TAB', 'Despre vehicul (Dotari)')}
                  />
                  <Tab
                    label={this.translatorService.Tranlate('MAVO_VEHICLE_PHOTOS_TAB', 'Poze')}
                  />
              </Tabs>
            </AppBar>
            <div>
              <TabPanel value={this.state.selectedTab} index={0}>
                <div className="m-3">
                  <div className="d-flex flex-row text-center flex-wrap justify-content-center">
                    <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
                  </div>
                  {!this.state.isLoading ? (
                    <MavoGeneralInformationContainer
                      {...this.props}
                      statuses={this.state.statuses}
                      disabled={true}
                      mavoVehicleAuction={this.props.mavoVehicleAuction}
                    />
                  ) : null}
                </div>
              </TabPanel>
              <TabPanel value={this.state.selectedTab} index={1}>
                <div className="m-3">
                  {!this.state.isLoading ? 
                    <MavoStatusDataContainer
                      {...this.props}
                      statuses={this.state.statuses} 
                      disabled={true}
                      conditionInfo={this.props.mavoVehicleState.mavoVehicle.vehicleConditionInfo}
                    />
                    : null}
                </div>
              </TabPanel>
              <TabPanel value={this.state.selectedTab} index={2}>
                <div className="m-3">
                  {!this.state.isLoading ? (
                    <MavoVehicleOptionsContainer
                      {...this.props}
                      statuses={this.state.statuses} 
                      disabled={true}
                      vehicleOptionInfo={this.props.mavoVehicleState.mavoVehicle.vehicleOptionInfo}
                      />
                  ) : null}
                </div>
              </TabPanel>
              <TabPanel value={this.state.selectedTab} index={3}>
                <div className="m-3">
                  {!this.state.isLoading ? (
                    <MavoAttachmentDataContainer
                      {...this.props}
                      statuses={this.state.statuses}
                      disabled={true} 
                      />
                  ) : null}
                </div>
              </TabPanel>
            </div>

            {this.state.isOfferDialogOpen && this.props.mavoVehicleAuction ? (
              <Dialog
                onClose={this.closeAddOfferDialog}
                aria-labelledby="customized-dialog-title"
                open={this.state.isOfferDialogOpen}
                fullScreen={true}
                fullWidth={true}
              >
                <DialogTitle
                  id="customized-dialog-title"
                  style={{
                    color: '#ffffff',
                    backgroundColor: 'var(--primary)',
                    textAlign: 'center'
                  }}
                >
                  <span style={{ fontSize: '20px', lineHeight: '24px' }}>
                    {this.translatorService.Tranlate('MAVO_VEHICLES_AUCTION_OFFER', 'Oferta')}
                  </span>
                  <IconButton
                    aria-label="close"
                    className="position-absolute"
                    style={{ right: 12, top: 12, color: '#ffffff' }}
                    onClick={this.closeAddOfferDialog}
                    size={'small'}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent dividers style={{ backgroundColor: '#fafafa' }}>
                  <AddAuctionOfferDialog
                    selectedAuction={this.props.mavoVehicleAuction}
                    closeDialog={this.closeAddOfferDialog}
                    goToUserAuctions={this.props.goToUserAuctions}
                  />
                </DialogContent>
              </Dialog>
            ) : null }
          </Card>
        </React.Fragment>
      </div>
    );
  }
}

export default connect(
  (state: ApplicationState, ownProps: ExternalMavoVehicleDetailsViewFormProps) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app,
    vehicleState: state.vehicle,
    mavoVehicleState: state.mavoVehicle,
    mavoVehicleAuctionState: state.mavoVehicleAuction,
  }),
{ ...CaseSettingsActionCreators, ...VehicleActionCreators, ...MavoVehicleActionCreators, ...VehicleAuctionActionCreators }
)(withSnackbar(MavoVehicleDetailsViewForm as any));
